var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('checkmark-filled-16',{staticClass:"checkmark-icon outer-icon-fill"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }